// extracted by mini-css-extract-plugin
export var cardHeader = "_ga-0";
export var reorderHandle = "_ga-3";
export var titleArea = "_ga-1";
export var titleAreaWithHandle = "_ga-2";